<app-task-panel
    [(visible)]="taskPanelVisible"
    [selectedTask]="selectedTask"
    (onTaskPanelHide)="onTaskPanelHide()"
>
</app-task-panel>

